<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " style="padding-bottom: 20px">
    <div id="g2ede8" class="operations-content sc_root">
      <h2 id="gf7b16" class="operations-head detail_title_20">
        <div class="operations-head Financial-icon-part">
          <div class="sc_root_head_title">
            <span class="operations-head">{{
              $t("ContentTabs.SupplyChain")
            }}</span>
            <div class="Financial-icon-part Financial-icon-parttwo">
              <svg
                t="1749001947538"
                class="icon sc_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6416"
              >
                <path
                  d="M528 1024C793.6 1024 1024 793.6 1024 528 1024 230.4 793.6 0 528 0 230.4 0 0 230.4 0 528 0 793.6 230.4 1024 528 1024zM512 64c246.4 0 448 201.6 448 448s-201.6 448-448 448S64 758.4 64 512 265.6 64 512 64z"
                  fill="#FFC800"
                  p-id="6417"
                ></path>
                <path
                  d="M512 256m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
                  fill="#FFC800"
                  p-id="6418"
                ></path>
                <path
                  d="M640 768h-64V384h-160v32h64v352h-64v32h224z"
                  fill="#FFC800"
                  p-id="6419"
                ></path>
              </svg>
            </div>
            <div class="Financial-icon-box Financial-icon-boxtwo">
              {{ $t("SupplyChain.Illustratesthesubjectcompany") }}
            </div>
          </div>
          <el-button
            class="custom-refresh-btn"
            v-if="showRefreshBtn"
            icon="el-icon-refresh-right"
            @click="GoBack()"
          ></el-button>
        </div>
      </h2>
      <div class="operations-box">
        <div ref="SupplyChainEchart" style="width: 100%; height: 642px"></div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import { getSupplyChain } from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      nodes: [], //{ name: 'Climate change' }
      links: [],
      reLoginVis: false,
      companyList: [],
      showRefreshBtn: false,
    };
  },
  mounted() {
    this.getData();
    console.log("xxxx");
    this.$emit("UpdatamarkTotalList", []);
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      if (this.links) {
        this.suppleEchart();
      }
    },
    getData() {
      getSupplyChain({
        id3a: this.$route.query.id3a,
        companyName: encodeURIComponent(this.$route.query.companyName),
      })
        .then((result) => {
          // let data = JSON.parse(crypto.decrypt(result));
          let data = result;
          if (data.code == 200) {
            const listNode = data.data.nodes;
            let arr = [];
            const listLinks = data.data.links;
            this.companyList = data.data.nodes;
            let arrLink = [];

            listNode.forEach((item) => {
              const pobj = { name: item.nameEn };
              arr.push(pobj);
            });
            this.nodes = arr;

            listLinks.forEach((item, index) => {
              const obj = {
                source: item.sourceEn,
                target: item.targetEn,
                value: item.value,
              };
              arrLink.push(obj);
            });
            // this.linkpre = arrLink
            this.links = arrLink;
            // this.findLink()
            this.suppleEchart();
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },

    suppleEchart() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      const option = {
        grid: {
          left: "0%", // 调整这个数值来控制图表在容器中的左侧位置
          // 其他 grid 相关设置
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            data: that.nodes,
            links: that.links,
            emphasis: {
              focus: "adjacency",
            },
            levels: [
              {
                depth: 0,
                itemStyle: {
                  color: "#fbb4ae",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 1,
                itemStyle: {
                  color: "#b3cde3",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 2,
                itemStyle: {
                  color: "#ccebc5",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 3,
                itemStyle: {
                  color: "#decbe4",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
            ],
            lineStyle: {
              curveness: 0.5,
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.echartsBox.resize();
      this.echartsBox.getZr().on("click", (event) => {
        // 第三层文字点击事件
        // encodeURIComponent
        let id = this.companyList.find(
          (item) => item.nameEn == event.topTarget.style.text,
        )?.aaaId;
        let name = this.companyList.find(
          (item) => item.nameEn == event.topTarget.style.text,
        )?.name;
        if (id) {
          this.showRefreshBtn = this.$route.query.id3a == id ? false : true;
          getSupplyChain({
            id3a: id,
            companyName: encodeURIComponent(name),
          })
            .then((result) => {
              // let data = JSON.parse(crypto.decrypt(result));
              let data = result;
              if (data.code == 200) {
                const listNode = data.data.nodes;
                let arr = [];
                const listLinks = data.data.links;
                this.companyList = data.data.nodes;
                let arrLink = [];

                listNode.forEach((item) => {
                  const pobj = { name: item.nameEn };
                  arr.push(pobj);
                });
                this.nodes = arr;

                listLinks.forEach((item, index) => {
                  const obj = {
                    source: item.sourceEn,
                    target: item.targetEn,
                    value: item.value,
                  };
                  arrLink.push(obj);
                });
                // this.linkpre = arrLink
                this.links = arrLink;
                // this.findLink()
                this.echartsBox.getZr().off("click");
                this.suppleEchart();
              }
            })
            .catch((err) => {
              this.reLoginVis = String(err).includes("403");
            });
        }
      });
    },
    GoBack() {
      window.location.reload();
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-content {
  padding: 30px 40px;
  height: 100%;
}

.operations-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Arial Bold";
  font-size: 26px;
  color: #1290c9;
  line-height: 27px;
  text-align: left;
  font-style: normal;
}

.sc_icon {
  width: 26px;
  height: 26px;
  vertical-align: middle;
  margin-bottom: 2px;
}

.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.Financial-icon-box {
  display: none;
  width: 500px;
  position: absolute;
  left: 0;
  top: 40px;
  z-index: 10;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: "Arial";
  font-size: 18px;
  color: #29445d;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.Financial-icon-part {
  position: relative;
}

.Financial-icon-part :hover .Financial-icon-box {
  display: block;
}

.sc_root .operations-box {
  margin-top: 10px;
  margin-left: 115px;
  margin-right: 115px;
}

/*cssStart*/

/*cssEnd*/
.sc_root_head_title {
  display: flex;
  gap: 8px;
}

.custom-refresh-btn {
  width: 72px;
  height: 50px;
  padding: 6px 17px;
  background: #f5f5f5;
  border-radius: 25px;
  color: #409eff;
}
.custom-refresh-btn:hover {
  color: #66b1ff;
  background-color: #f6f8fa;
}

.el-button {
  min-width: auto;
}

.custom-refresh-btn /deep/ i {
  font-size: 32px;
}

@media screen and (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
  }

  .operations-head {
    font-size: 20px;
    line-height: 40px;
  }

  .sc_root_head_title {
    gap: 6px;
  }

  .sc_icon {
    width: 20px;
    height: 20px;
  }

  .operations-content {
    padding: 22px 30px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }

  .Financial-icon-box {
    width: 376px;
    padding: 15px;
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    font-size: 14px;
    line-height: 22px;
  }

  .sc_root .operations-box {
    margin-top: 15px;
    margin-left: 86px;
    margin-right: 86px;
  }

  .custom-refresh-btn {
    width: 54px;
    height: 38px;
    padding: 5px 13px;
    border-radius: 25px;
  }

  .custom-refresh-btn /deep/ i {
    font-size: 24px;
  }
}

@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 26px;
  }

  .operations-head {
    font-size: 18px;
    line-height: 20px;
  }

  .sc_root_head_title {
    gap: 5px;
  }

  .sc_icon {
    width: 18px;
    height: 18px;
  }

  .operations-content {
    padding: 20px 26px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }

  .Financial-icon-box {
    width: 336px;
    top: 30px;
    padding: 12px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    line-height: 18px;
  }

  .sc_root .operations-box {
    margin-top: 6px;
    margin-left: 78px;
    margin-right: 78px;
  }

  .custom-refresh-btn {
    width: 46px;
    height: 32px;
    padding: 4px 11px;
    border-radius: 18px;
  }

  .custom-refresh-btn /deep/ i {
    font-size: 22px;
  }
}
</style>
